import { cn } from "@/shared/utils/cn";
import { EditorContent, useEditor } from "@tiptap/react";
import { getRichTextExtensions } from "./extensions";
import "./richText.css";

interface RichTextContentProps {
  html: string;
  // Polls are shown without voting
  previewPolls?: boolean;
  className?: string;
}

/**
 * Shows html from the RichTextEditor. It goes through the same editor schema,
 * read only, so only the known nodes and marks render and polls become live.
 */
const RichTextContent = ({
  html,
  previewPolls = false,
  className,
}: RichTextContentProps) => {
  const editor = useEditor(
    {
      editable: false,
      extensions: getRichTextExtensions({ editable: false, previewPolls }),
      content: html,
      editorProps: { attributes: { class: cn("rich-text", className) } },
    },
    [html, previewPolls]
  );

  return <EditorContent editor={editor} />;
};

export default RichTextContent;
